
import { computed, defineComponent } from 'vue'
import CElementLoading from '@invivodf/common/src/application/components/CElementLoading/CElementLoading.vue'
import CAssociationsStep from './association/CEditableAssociationsStep.vue'
import CSummaryStep from './CSummaryStep.vue'
import { useForm } from '../composables/useForm'
import CGeneralInformationsStep from './CGeneralInformationsStep.vue'
import IdfStepper from './IdfStepper/IdfStepper.vue'

export default defineComponent({
  name: 'CDiscountForm',
  components: {
    CElementLoading,
    IdfStepper,
    CGeneralInformationsStep,
    CAssociationsStep,
    CSummaryStep,
  },
  props: {
    fromActive: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { associationStepRequired, discountForm } = useForm()
    return {
      showAssociationStep: associationStepRequired,
      loading: computed(() => !discountForm.value),
    }
  },
})
